import { Grid, Tooltip, Box } from '@mui/material';
import { FC, useState } from 'react';
import { SCUIContent } from '../../atomic/organisms';
import { CustomerCommand } from '../../services/command';
import { SCUICustomDataGrid, SCUITextFieldWithSelectBox } from '../../atomic/molecules';
import { useTranslation } from 'react-i18next';
import { SCUILoadingLinear } from '../../atomic/atoms';
import TimeHelper from '../../utils/time';
import { CAN } from './customerAnonymization.classes';

export const CustomerAnonymizationHistory: FC<any> = () => {
    const [anonymizationList, setAnonymizationList] = useState<any>([]);
    const [documentType, setDocumentType] = useState(1);
    const [searchedText, setSearchedText] = useState('');
    const [pageSize, setPageSize] = useState(5);
    const { t } = useTranslation();
    const [pageLoading, setPageLoading] = useState(false);
    const [grid, setGrid] = useState(false);

    const handleSearchClick = () => {
        AnonymizationList();
    };
    const AnonymizationList = () => {
        setGrid(true);
        setPageLoading(true);
        let params: any = {};
        if (documentType === 1) params.Phone = normalizePhoneNumber(searchedText.trim());
        else if (documentType === 2) params.Email = searchedText.trim();
        CustomerCommand.GetCustomerAnonymizedHistory(params)
            .then((res: any) => {
                if (res) {
                    let parseData = res.map((item: any) => {
                        return {
                            customerId: item.customerId || '-',
                            byUserName: item.byUserName || ' - ',
                            email: item.email || ' ',
                            anonymizedDate: item.anonymizedDate || '-',
                            anonymousId: item.anonymousId || '-',
                            phone: item.phone || ' -  ',
                            platform: item.platform !== null ? item.platform : ' - ',
                            orderCount: item.orderCount || ' - ',
                        };
                    });
                    setAnonymizationList(parseData);
                }
            })
            .finally(() => {
                setPageLoading(false);
            });
    };

    function normalizePhoneNumber(phoneNumber: any) {
        // Eğer numara 0090 ile başlıyorsa
        if (phoneNumber.startsWith('0090')) {
            return phoneNumber.substring(4); // 0090'ı kes ve geri kalanını al
        }
        // Eğer numara 0 ile başlıyorsa
        else if (phoneNumber.startsWith('0')) {
            return phoneNumber.substring(1); // Sadece ilk 0'ı kes ve geri kalanını al
        }
        // Eğer numara sadece rakamlardan oluşuyorsa
        else {
            return phoneNumber; // Başında 90 olmadığı için eklemeye gerek yok
        }
    }
    return (
        <SCUIContent className={`${CAN.histPage} `}>
            <SCUILoadingLinear display={pageLoading} />
            <Grid
                className={CAN.histTitle}
                container
                sx={{ marginBottom: '2rem' }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                <h2>Müşteri Anonimleştirme Geçmişi</h2>
            </Grid>
            <Grid
                className={CAN.histSearch}
                size={{
                    xl: 12,
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                <Box className={CAN.inputComposite}>
                    <SCUITextFieldWithSelectBox
                        placeholder={' '}
                        selectList={[
                            { value: 1, text: t('general.phoneNumber') },
                            { value: 2, text: t('lcwMoney.email') },
                        ]}
                        onChangeSelect={(event: any) => {
                            setDocumentType(event.target.value as number);
                            setAnonymizationList([]);
                        }}
                        selectValue={documentType}
                        onChangeTextField={(event: any) => {
                            setSearchedText(event.target.value.trim());
                        }}
                        onClickButton={() => handleSearchClick()}
                        onKeyPressTextField={(e: any) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleSearchClick();
                            }
                        }}
                    />
                </Box>
            </Grid>
            {grid ? (
                <Grid
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <Box className={CAN.histGrid}>
                        <SCUICustomDataGrid
                            randomId
                            rows={anonymizationList}
                            columns={[
                                { field: 'customerId', headerName: 'Müşteri No', flex: 1 },
                                {
                                    field: 'anonymousId',
                                    headerName: 'Anonim No',
                                    flex: 1,
                                    renderCell: (params: any) => {
                                        return (
                                            <div>
                                                <Tooltip title={params.row.anonymousId}>
                                                    <p>{params.row.anonymousId}</p>
                                                </Tooltip>
                                            </div>
                                        );
                                    },
                                },
                                {
                                    field: 'email',
                                    headerName: 'Email',
                                    flex: 1,
                                    renderCell: (params: any) => {
                                        return (
                                            <div>
                                                <Tooltip title={params.row.email}>
                                                    <p>{params.row.email}</p>
                                                </Tooltip>
                                            </div>
                                        );
                                    },
                                },
                                { field: 'phone', headerName: 'Telefon', flex: 1 },
                                {
                                    field: 'anonymizedDate',
                                    headerName: 'Tarih',
                                    flex: 1,
                                    renderCell: (params: any) => {
                                        return (
                                            <div>
                                                <Tooltip
                                                    title={TimeHelper.formatDateHourSecond(params.row.anonymizedDate)}
                                                >
                                                    <p>
                                                        {params.row.anonymizedDate === '' ||
                                                        params.row.anonymizedDate === null ||
                                                        params.row.anonymizedDate === ' - '
                                                            ? ' - '
                                                            : TimeHelper.formatDateHourSecond(
                                                                  params.row.anonymizedDate
                                                              )}
                                                    </p>
                                                </Tooltip>
                                            </div>
                                        );
                                    },
                                },
                                {
                                    field: 'byUserName',
                                    headerName: 'İşlem Yapan Kullanıcı',
                                    flex: 1,
                                    renderCell: (params: any) => {
                                        return (
                                            <div>
                                                <Tooltip title={params.row.byUserName}>
                                                    <p>{params.row.byUserName}</p>
                                                </Tooltip>
                                            </div>
                                        );
                                    },
                                },
                                { field: 'platform', headerName: 'Platform', flex: 1 },
                                { field: 'orderCount', headerName: 'Sipariş Sayısı', flex: 1 },
                            ]}
                            pageSize={pageSize}
                            onPageSizeChange={(i: number) => {
                                setPageSize(i);
                            }}
                        />
                    </Box>
                </Grid>
            ) : (
                ''
            )}
        </SCUIContent>
    );
};
